import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

export const InterfaceElement = styled.div<{ fullHeight?: boolean }>`
  width: 100%;
  background-color: white;
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}
`

export const ComponentStructure = styled.div<{
  spacingClass: HeightClass
  fullHeight?: boolean
}>`
  border-radius: 6px;
  border: 1px solid #c9c9cb;
  padding: ${({ theme, spacingClass }) => theme.card[spacingClass]?.padding}px;
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}
`
